<template>
  <div class="flex flex-col space-y-5 justify-center items-center">
    <h2 class="font-bold">loading...</h2>
    <a-spin />
  </div>
</template>


